import { render, staticRenderFns } from "./CardPieChart.vue?vue&type=template&id=3f24cd0e&scoped=true&"
import script from "./CardPieChart.vue?vue&type=script&lang=js&"
export * from "./CardPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f24cd0e",
  null
  
)

export default component.exports